// utils/flashcardService.js
import { auth, db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";

// Read endpoint from environment
const FLASHCARD_API = process.env.REACT_APP_FLASHCARD_API;

// Track in-flight flashcard requests per contentId
const inFlightFlashcardRequests = new Map();
export const isFlashcardsRequestInFlight = (contentId) => inFlightFlashcardRequests.has(contentId);

export const generateFlashcardsForSession = async (contentId) => {
  const user = auth.currentUser;
  if (!contentId || !user) return [];

  // De-duplicate concurrent requests
  if (inFlightFlashcardRequests.has(contentId)) {
    return inFlightFlashcardRequests.get(contentId);
  }

  const promise = (async () => {
    try {
      if (!FLASHCARD_API) {
        throw new Error('Flashcard API endpoint not configured. Set REACT_APP_FLASHCARD_API in .env');
      }
      const token = await user.getIdToken();

      const payload = {
        contentId,
        maxCards: 30
      };

      const resp = await fetch(FLASHCARD_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify(payload)
      });

      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error('Flashcard API error: ' + resp.status + ' ' + txt);
      }

      const data = await resp.json();
      if (!data || data.success === false) {
        throw new Error('Flashcard API failed: ' + JSON.stringify(data));
      }

      const cards = Array.isArray(data.cards) ? data.cards : [];
      return cards;
    } finally {
      inFlightFlashcardRequests.delete(contentId);
    }
  })();

  inFlightFlashcardRequests.set(contentId, promise);
  return promise;
};

export const fetchLatestFlashcards = async (contentId) => {
  try {
    const user = auth.currentUser;
    if (!user || !contentId) return [];
    const flashcardsCol = collection(db, "users", user.uid, "Sessions", contentId, "Flashcards");
    // order by timestamp descending and pick the first doc
    const q = query(flashcardsCol, orderBy("timestamp", "desc"));
    const snap = await getDocs(q);
    if (!snap || snap.empty) return [];
    const latestDoc = snap.docs[0];
    const data = latestDoc.data();
    return Array.isArray(data?.cards) ? data.cards : [];
  } catch (e) {
    return [];
  }
};
